var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7215 5.04211C10.7215 3.62723 10.7215 2.9198 10.4566 2.37939C10.2236 1.90403 9.85182 1.51756 9.39451 1.27535C8.87459 1 8.19409 1 6.83291 1H4.88861C3.52743 1 2.84693 1 2.32699 1.27535C1.86967 1.51756 1.4979 1.90403 1.26491 2.37939C1 2.9198 1 3.62723 1 5.04211V12.9579C1 14.3728 1 15.0802 1.26491 15.6206C1.4979 16.096 1.86967 16.4824 2.32699 16.7246C2.84693 17 3.52743 17 4.88861 17H6.83291C8.19409 17 8.87459 17 9.39451 16.7246C9.85182 16.4824 10.2236 16.096 10.4566 15.6206C10.7215 15.0802 10.7215 14.3728 10.7215 12.9579V11.7368H7.48101C6.02692 11.7368 4.8481 10.5115 4.8481 9C4.8481 7.48851 6.02692 6.26316 7.48101 6.26316H10.7215V5.04211ZM12.8409 7.218C12.4454 6.80693 12.4454 6.14044 12.8409 5.72936C13.2364 5.31828 13.8776 5.31828 14.273 5.72936L16.7034 8.25566C17.0989 8.66678 17.0989 9.33322 16.7034 9.74434L14.273 12.2707C13.8776 12.6817 13.2364 12.6817 12.8409 12.2707C12.4454 11.8595 12.4454 11.1931 12.8409 10.782L13.5426 10.0526H7.48101C6.9217 10.0526 6.46835 9.58139 6.46835 9C6.46835 8.41861 6.9217 7.94737 7.48101 7.94737H13.5426L12.8409 7.218Z",
    fill: "black"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.70851f450871812569c006b9acf9f34d.svg";
export { ForwardRef as ReactComponent };